/** @format */

import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { options } from "utils/constant.data";
import { useUpdateFellowProfileMutation } from "store/services/adminAPI";
import {
  Channels,
  extractErrorMessage,
  replaceUnderscoresWithSpaces,
} from "utils/strings";

const Accessibility = ({ currentProfile, setActiveTab }) => {
  const [updateFellowProfile, { isLoading: updating }] =
    useUpdateFellowProfileMutation();

  // const handleSubmit = async (values) => {
  //   await updateFellowProfile({
  //     ...values,
  //   })
  //     .unwrap()
  //     .then(() => {
  //       const message = `✔️ Profile updated !`;
  //       toast.success(message, {
  //         position: "top-right",
  //         autoClose: 2500,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //       });
  //       setActiveTab("accessibility");
  //     })
  //     .catch((error) => {
  //       const formattedError = extractErrorMessage(error);
  //       Swal.fire({
  //         title:
  //           replaceUnderscoresWithSpaces(error?.data?.code) || "Error Occured",
  //         text: formattedError,
  //         iconHtml: ` <i class="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i>`,
  //         showCloseButton: true,
  //         customClass: {
  //           icon: "no-border",
  //         },
  //         confirmButtonText: "Try Again",
  //       });
  //     });
  //   // }
  // };

  const handleSubmit = async (values) => {
  // Keep only keys that have a real value (not "", null, undefined)
  const filteredValues = Object.fromEntries(
    Object.entries(values).filter(
      ([, value]) => value !== "" && value !== null && value !== undefined
    )
  );

  await updateFellowProfile(filteredValues)
    .unwrap()
    .then(() => {
      toast.success("✔️ Profile updated !", {
        position: "top-right",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
      });
      setActiveTab("accessibility");
    })
    .catch((error) => {
      const formattedError = extractErrorMessage(error);
      Swal.fire({
        title: replaceUnderscoresWithSpaces(error?.data?.code) || "Error Occured",
        text: formattedError,
        iconHtml: `<i class="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i>`,
        showCloseButton: true,
        customClass: { icon: "no-border" },
        confirmButtonText: "Try Again",
      });
    });
};


  const formik = useFormik({
    initialValues: {
      has_participated_in_internship_or_apprenticeships:
        currentProfile?.has_participated_in_internship_or_apprenticeships ??
        false,
      has_past_experience_with_similar_programs:
        currentProfile?.has_past_experience_with_similar_programs ?? false,
      how_did_you_hear_about_the_program:
        currentProfile?.how_did_you_hear_about_the_program ?? "",
      is_interested_in_participating_in_mentorship_program:
        currentProfile?.is_interested_in_participating_in_mentorship_program ??
        false,
      would_like_to_join_alumni_network_post_graduation:
        currentProfile?.would_like_to_join_alumni_network_post_graduation ??
        false,
      is_interested_in_serving_as_mentor_for_future_cohorts:
        currentProfile?.is_interested_in_serving_as_mentor_for_future_cohorts ??
        false,
      consents_to_data_collection_for_program_purpose:
        currentProfile?.consents_to_data_collection_for_program_purpose ??
        false,
      agrees_to_programs_terms_and_conditions:
        currentProfile?.agrees_to_programs_terms_and_conditions ?? false,
      authorizes_use_of_media_in_program_related_content:
        currentProfile?.authorizes_use_of_media_in_program_related_content ??
        false,
    },
    onSubmit: handleSubmit,
    enableReinitialize: true,
    validationSchema: FormSchema,
  });

  return (
    <div className="basic-form">
      <h5>Accessibility and Program Engagement</h5>

      <form onSubmit={formik.handleSubmit} className={updating ? "disabled" : ""}>
        <div className="row g-3 mb-3">
          <div className="col-md-4 form-balance">
            <label className="mb-1">
              <strong>
                Have you participated in any internships or apprenticeships??
              </strong>
            </label>
            <div className="d-flex align-items-center justify-content-between mb-3">
              {options.map((item, index) => {
                return (
                  <button
                    key={index}
                    type="button"
                    className={`btn btn-outline-grey flex-grow me-2 ${
                      formik?.values
                        ?.has_participated_in_internship_or_apprenticeships ===
                      item?.value
                        ? "active"
                        : ""
                    }`}
                    onClick={() => {
                      formik.setFieldValue(
                        "has_participated_in_internship_or_apprenticeships",
                        item?.value
                      );
                    }}
                  >
                    {item?.label}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="col-md-4 form-balance">
            <label className="mb-1">
              <strong>
                Do you have any past experience with similar training programs?
              </strong>
            </label>
            <div className="d-flex align-items-center justify-content-between mb-3">
              {options.map((item, index) => {
                return (
                  <button
                    key={index}
                    type="button"
                    className={`btn btn-outline-grey flex-grow me-2 ${
                      formik?.values
                        ?.has_past_experience_with_similar_programs ===
                      item?.value
                        ? "active"
                        : ""
                    }`}
                    onClick={() => {
                      formik.setFieldValue(
                        "has_past_experience_with_similar_programs",
                        item?.value
                      );
                    }}
                  >
                    {item?.label}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="col-md-4 form-balance">
            <label className="mb-1">
              <strong>How did you hear about the 3MTT program?</strong>
            </label>
            <select
              id="how_did_you_hear_about_the_program"
              name="how_did_you_hear_about_the_program"
              value={formik.values.how_did_you_hear_about_the_program}
              className="form-control mb-3"
              onChange={(e) => {
                const selectedSkill = e.target.value;
                formik.setFieldValue(
                  "how_did_you_hear_about_the_program",
                  selectedSkill
                );
              }}
              {...formik.getFieldProps("how_did_you_hear_about_the_program")}
            >
              {Channels.map((skill) => {
                return <option value={skill.value}>{skill.label}</option>;
              })}
            </select>
            {formik.errors.how_did_you_hear_about_the_program ? (
              <div className="text-danger mt-2 fs-12">
                {formik.errors.how_did_you_hear_about_the_program}
              </div>
            ) : null}
          </div>

          <div className="col-md-4 form-balance">
            <label className="mb-1">
              <strong>
                Are you interested in participating in our mentorship program?
              </strong>
            </label>
            <div className="d-flex align-items-center justify-content-between mb-3">
              {options.map((item, index) => {
                return (
                  <button
                    key={index}
                    type="button"
                    className={`btn btn-outline-grey flex-grow me-2 ${
                      formik?.values
                        ?.is_interested_in_participating_in_mentorship_program ===
                      item?.value
                        ? "active"
                        : ""
                    }`}
                    onClick={() => {
                      formik.setFieldValue(
                        "is_interested_in_participating_in_mentorship_program",
                        item?.value
                      );
                    }}
                  >
                    {item?.label}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="col-md-4 form-balance">
            <label className="mb-1">
              <strong>
                Would you like to join the Alumni Network after graduation?
              </strong>
            </label>
            <div className="d-flex align-items-center justify-content-between mb-3">
              {options.map((item, index) => {
                return (
                  <button
                    key={index}
                    type="button"
                    className={`btn btn-outline-grey flex-grow me-2 ${
                      formik?.values
                        ?.would_like_to_join_alumni_network_post_graduation ===
                      item?.value
                        ? "active"
                        : ""
                    }`}
                    onClick={() => {
                      formik.setFieldValue(
                        "would_like_to_join_alumni_network_post_graduation",
                        item?.value
                      );
                    }}
                  >
                    {item?.label}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="col-md-4 form-balance">
            <label className="mb-1">
              <strong>
                Would you be interested in serving as a mentor or coach in
                future cohorts?
              </strong>
            </label>
            <div className="d-flex align-items-center justify-content-between mb-3">
              {options.map((item, index) => {
                return (
                  <button
                    key={index}
                    type="button"
                    className={`btn btn-outline-grey flex-grow me-2 ${
                      formik?.values
                        ?.is_interested_in_serving_as_mentor_for_future_cohorts ===
                      item?.value
                        ? "active"
                        : ""
                    }`}
                    onClick={() => {
                      formik.setFieldValue(
                        "is_interested_in_serving_as_mentor_for_future_cohorts",
                        item?.value
                      );
                    }}
                  >
                    {item?.label}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="col-md-4 form-balance">
            <label className="mb-1">
              <strong>
                Do you consent to data collection for program purposes?
              </strong>
            </label>
            <div className="d-flex align-items-center justify-content-between mb-3">
              {options.map((item, index) => {
                return (
                  <button
                    key={index}
                    type="button"
                    className={`btn btn-outline-grey flex-grow me-2 ${
                      formik?.values
                        ?.consents_to_data_collection_for_program_purpose ===
                      item?.value
                        ? "active"
                        : ""
                    }`}
                    onClick={() => {
                      formik.setFieldValue(
                        "consents_to_data_collection_for_program_purpose",
                        item?.value
                      );
                    }}
                  >
                    {item?.label}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="col-md-4 form-balance">
            <label className="mb-1">
              <strong>
                Do you agree to the program's terms and conditions?
              </strong>
            </label>
            <div className="d-flex align-items-center justify-content-between mb-3">
              {options.map((item, index) => {
                return (
                  <button
                    key={index}
                    type="button"
                    className={`btn btn-outline-grey flex-grow me-2 ${
                      formik?.values
                        ?.agrees_to_programs_terms_and_conditions ===
                      item?.value
                        ? "active"
                        : ""
                    }`}
                    onClick={() => {
                      formik.setFieldValue(
                        "agrees_to_programs_terms_and_conditions",
                        item?.value
                      );
                    }}
                  >
                    {item?.label}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="col-md-4 form-balance">
            <label className="mb-1">
              <strong>
                Authorize the use of your media in program-related content?
              </strong>
            </label>
            <div className="d-flex align-items-center justify-content-between mb-3">
              {options.map((item, index) => {
                return (
                  <button
                    key={index}
                    type="button"
                    className={`btn btn-outline-grey flex-grow me-2 ${
                      formik?.values
                        ?.authorizes_use_of_media_in_program_related_content ===
                      item?.value
                        ? "active"
                        : ""
                    }`}
                    onClick={() => {
                      formik.setFieldValue(
                        "authorizes_use_of_media_in_program_related_content",
                        item?.value
                      );
                    }}
                  >
                    {item?.label}
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end">
          <button
            onClick={() => setActiveTab("learning")}
            type="button"
            className="submit btn btn-outline-grey  me-2"
          >
            Back
          </button>
          <button
            type="submit"
            className="submit btn btn-pigment-green"
            disabled={updating || !formik.dirty}
          >
            {updating ? (
              <span
                role="button"
                aria-hidden="true"
                className="spinner-border spinner-border-sm ms-2"
              ></span>
            ) : (
              "Save"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Accessibility;

const FormSchema = Yup.object().shape({
  has_participated_in_internship_or_apprenticeships: Yup.string(),
    // .required("This option is required"),

  has_past_experience_with_similar_programs: Yup.string(),
    // .required("This option is required"),

  how_did_you_hear_about_the_program: Yup.string(),
    // .required("This option is required"),

  is_interested_in_participating_in_mentorship_program: Yup.string(),
    // .required("This option is required"),

  would_like_to_join_alumni_network_post_graduation: Yup.string(),
    // .required("This option is required"),

  is_interested_in_serving_as_mentor_for_future_cohorts: Yup.string(),
    // .required("This option is required"),

  consents_to_data_collection_for_program_purpose: Yup.string(),
    // .required("This option is required"),

  agrees_to_programs_terms_and_conditions: Yup.string(),
    // .required("This option is required"),

  authorizes_use_of_media_in_program_related_content: Yup.string()
    // .required("This option is required"),
});

